type GetKeyPaths = (obj: { [key: string]: any }, prefix?: string) => string[]

export const getKeyPaths: GetKeyPaths = (obj, prefix = '') => {
  if (!obj || typeof obj !== 'object') {
    return []
  }
  
  const keys = Object.keys(obj)
  return keys.reduce((acc, key) => {
    const value = obj[key]
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return [...acc, ...getKeyPaths(value, prefix ? `${prefix}.${key}` : key)]
    } else {
      return [...acc, prefix ? `${prefix}.${key}` : key]
    }
  }, [] as string[])
}
